import './component/request-appointment';
import './component/register-patient';
import './component/modal';

